import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const Notepad = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.029}
      d="M9.086 11.229h6.171m-6.171 3.085H13.2M9.086 3v3.086M15.257 3v3.086M12.171 3v3.086M7.03 21h10.285c.568 0 1.029-.46 1.029-1.029v-14.4c0-.568-.46-1.028-1.029-1.028H7.03c-.57 0-1.03.46-1.03 1.027v14.4c0 .57.46 1.03 1.029 1.03"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(Notepad) as SvgIcon;
export { ForwardRef as ReactComponent };
